import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { App } from './App';
import { GegevensProvider } from './gegevens';
import { Foutgrens } from './onderdelen/Foutgrens';
import { pasAnimatiesToe } from './schermen/Instellingen';
import './styles/basis.css';

pasAnimatiesToe();

/**
 * Vangnet voor een vastgelopen login.
 *
 * De applicatie hoort nooit onder /.auth/ te draaien; dat pad is van de Static Web
 * App zelf. Gebeurt het toch — bijvoorbeeld doordat een routeregel de callback
 * afvangt — dan is de login op dat moment wél geslaagd, alleen is de doorverwijzing
 * blijven hangen. Dan sturen we de gebruiker zelf naar binnen, één keer, zodat een
 * verkeerde configuratie geen doodlopende pagina oplevert.
 */
const AUTH_OMLEIDING = 'houtstaat.authOmleiding';

if (window.location.pathname.startsWith('/.auth/')) {
  if (sessionStorage.getItem(AUTH_OMLEIDING)) {
    // Al een keer geprobeerd: niet nog eens, anders ontstaat er een lus.
    document.getElementById('root')!.innerHTML =
      '<div style="font-family:system-ui,sans-serif;padding:40px;max-width:640px">' +
      '<h1 style="font-size:20px">Inloggen is niet afgerond</h1>' +
      '<p style="color:#4b5563">De aanmelding bij Entra ID lukte, maar de doorverwijzing naar de ' +
      'applicatie bleef hangen. Ga naar <a href="/">de startpagina</a> om het opnieuw te proberen.</p></div>';
  } else {
    sessionStorage.setItem(AUTH_OMLEIDING, '1');
    window.location.replace('/');
  }
} else {
  sessionStorage.removeItem(AUTH_OMLEIDING);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      {/* HashRouter: een Static Web App serveert dan zonder extra rewriteregels. */}
      <HashRouter>
        <Foutgrens>
          <GegevensProvider>
            <App />
          </GegevensProvider>
        </Foutgrens>
      </HashRouter>
    </StrictMode>,
  );
}
